import { toJS } from "mobx";
import get from "lodash/get";
import isArray from "lodash/isArray";
import isObject from "lodash/isObject";

// Get sort key from column, either a column property or data code
export const getSortKeyFromColumn = (column) => {
    const { property: key, data } = column;

    // If data is an array there are multiple data points configured in the column.
    // So, the key will be in one configured as sortable or the first one.
    if (isArray(toJS(data))) {
        const columnData = data.find(d => d.sortable) || data[0];
        return get(columnData, 'code') || get(columnData, 'property');
    }

    if (isObject(toJS(data))) {
        return get(data, 'code');
    }

    return key;
};

export default getSortKeyFromColumn;


// WEBPACK FOOTER //
// ./src/utils/getSortKeyFromColumn.ts